import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Facebook, ChevronDown } from 'lucide-react';
import { FaGoogle } from 'react-icons/fa';

const DemoFooter = () => {
  const [openSection, setOpenSection] = useState(null);

  const footerData = {
    services: [
      { name: "Agentic AI Services", link: "/agentic-ai-services" },
      { name: "AI & Automation", link: "/ai-automation" },
      { name: "Product Engineering", link: "/product-engineering" },
      { name: "Performance Engineering", link: "/performance-engineering" },
      { name: "Cloud Engineering", link: "/cloud-engineering" },
      { name: "ServiceNow Consulting", link: "/servicenow-consulting" },
      { name: "Data & Analytics", link: "/data-analytics" },
      { name: "Infor M3 Solutions", link: "/infor-m3-solutions" },
      { name: "Infor EPM Services", link: "/infor-epm-services" },
      { name: "Global Capability Centers", link: "/global-capability-centers" },
      { name: "MES Solutions", link: "/manufacturing-execution-system" },
      { name: "Industrial Automation", link: "/industrial-automation" },
      { name: "Building Automation", link: "/building-automation-solutions" },
      { name: "Embedded Services", link: "/embedded-services" },
      { name: "Staff Augmentation", link: "/staff-augmentation" },
    ],
    capabilities: [
      { name: "AI Automation", link: "/capabilities/ai-automation" },
      { name: "Enterprise Applications", link: "/capabilities/enterprise-applications" },
      { name: "Digital Workflows", link: "/capabilities/digital-workflows" },
      { name: "Cloud Engineering", link: "/capabilities/cloud-engineering" },
      { name: "Industrial Engineering", link: "/capabilities/industrial-engineering" },
      { name: "Product Engineering", link: "/capabilities/product-engineering" },
      { name: "Quality Engineering", link: "/capabilities/quality-engineering" },
      { name: "Managed Services", link: "/capabilities/managed-services" },
    ],
    products: [
      { name: "Glodesk", link: "/glodesk" },
      { name: "Glokode", link: "/glokode" }
    ]
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <footer style={{ background: "linear-gradient(180deg, #F3F5FF 0%, #E5ECFF 100%)" }} className="w-full text-[#01386A] font-roboto overflow-hidden relative pt-[20px]">
      <div className="max-w-[1220px] mx-auto px-[20px] md:px-[60px] lg:px-[80px] relative z-10">

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-8 border-b border-[#01386A]">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-[60px] lg:gap-[100px] w-full md:w-auto">
            <Link to="/" className="mb-4 md:mb-0">
              <img src="/assets/nav/footer-logo.png" className="h-[35px] object-contain" alt="Logo" />
            </Link>
            <div className="flex flex-wrap justify-start md:justify-center gap-6 md:gap-10 text-[15px] font-medium">
              <Link to="/who-we-are" className="hover:text-[#01386A] font-graphik transition-colors">Who we are</Link>
              <Link to="/contact" className="hover:text-[#01386A] font-graphik transition-colors">Contact</Link>
              <Link to="/careers" className="hover:text-[#01386A] font-graphik transition-colors">Careers</Link>
            </div>
          </div>

          <div className="flex gap-3 mt-8 md:mt-0 w-full md:w-auto justify-start md:justify-end">
            <SocialIcon2 link='https://in.linkedin.com/company/mobikode-software' icon={<Linkedin size={16} fill="currentColor" />} />
            <SocialIcon2 link='https://share.google/c8Fo9HDXodQPahjf4' icon={<FaGoogle size={16} />} />
            <SocialIcon2 link='https://www.facebook.com/mobikode' icon={<Facebook size={16} fill="currentColor" />} />
            <SocialIcon2 link='https://clutch.co/profile/mobikode' icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.12 18.254a6.602 6.602 0 01-5.127-2.31 7.42 7.42 0 01-1.683-4.99c0-2.227.561-4.108 1.683-5.631a6.627 6.627 0 015.304-2.285 6.035 6.035 0 014.288 1.57c.1.09.15.223.15.4 0 .15-.05.275-.15.376l-1.378 1.377c-.112.113-.236.17-.376.17-.14 0-.27-.057-.39-.17a3.178 3.178 0 00-2.268-.902 3.525 3.525 0 00-2.833 1.253 4.887 4.887 0 00-1.077 3.393c0 1.5.358 2.645 1.077 3.443.719.797 1.663 1.196 2.833 1.196 1.127 0 2.062-.352 2.808-1.055.087-.087.2-.13.34-.13.14 0 .262.043.364.13l1.453 1.454c.1.1.15.226.15.376 0 .14-.05.263-.15.364a6.223 6.223 0 01-4.475 1.503zM21.246 13.065h-1.921c-.138 0-.256-.05-.353-.15a.485.485 0 01-.144-.351V3.41c0-.14.048-.258.144-.354.097-.097.215-.145.353-.145h1.921c.14 0 .259.048.356.145.097.096.146.214.146.354v9.154c0 .135-.049.252-.146.351a.488.488 0 01-.356.15z" />
              </svg>
            } />
            <SocialIcon2 link='https://www.glassdoor.com/Overview/Working-at-Mobikode-EI_IE5348831.11,19.htm' icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 18.25a6.25 6.25 0 110-12.5 6.25 6.25 0 010 12.5z" fill="currentColor" />
                <path d="M12 8.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z" fill="currentColor" />
                <path d="M17.5 12a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z" fill="none" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            } />
          </div>
        </div>

        <div className="relative py-10 md:py-16 lg:border-b border-[#01386A]">

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-8 w-full lg:w-[75%] relative z-10">

            <div className="col-span-1 md:col-span-2 border-b md:border-b-0 border-[#01386A] py-2 md:py-0">
              <button onClick={() => toggleSection('services')} className="w-full flex items-center justify-between py-2 md:py-0 md:cursor-default">
                <span className="text-[16px] font-bold font-graphik tracking-wide mb-0 md:mb-6">Services</span>
                <div className={`md:hidden transition-transform duration-300 ${openSection === 'services' ? 'rotate-180' : ''}`}>
                  <ChevronDown size={20} />
                </div>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${openSection === 'services' ? 'max-h-[1000px] pb-4' : 'max-h-0 md:max-h-none'}`}>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 !p-0">
                  {footerData.services.map((item, i) => (
                    <li key={i}>
                      <Link to={item.link} className="text-[13px] md:text-[14px] text-[#01386A] hover:text-[#01386A] transition-all block">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-span-1 border-b md:border-b-0 border-[#01386A] py-2 md:py-0">
              <button onClick={() => toggleSection('capabilities')} className="w-full flex items-center justify-between py-2 md:py-0 md:cursor-default">
                <span className="text-[16px] font-bold font-graphik tracking-wide mb-0 md:mb-6">Capabilities</span>
                <div className={`md:hidden transition-transform duration-300 ${openSection === 'capabilities' ? 'rotate-180' : ''}`}>
                  <ChevronDown size={20} />
                </div>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${openSection === 'capabilities' ? 'max-h-[1000px] pb-4' : 'max-h-0 md:max-h-none'}`}>
                <ul className="grid grid-cols-1 gap-y-3 !p-0">
                  {footerData.capabilities.map((item, i) => (
                    <li key={i}>
                      <Link to={item.link} className="text-[13px] md:text-[14px] text-[#01386A] hover:text-[#01386A] transition-all block">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-span-1 border-b md:border-b-0 border-[#01386A] py-2 md:py-0">
              <button onClick={() => toggleSection('products')} className="w-full flex items-center justify-between py-2 md:py-0 md:cursor-default">
                <span className="text-[16px] font-bold font-graphik tracking-wide mb-0 md:mb-6">Products</span>
                <div className={`md:hidden transition-transform duration-300 ${openSection === 'products' ? 'rotate-180' : ''}`}>
                  <ChevronDown size={20} />
                </div>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${openSection === 'products' ? 'max-h-[500px] pb-4' : 'max-h-0 md:max-h-none'}`}>
                <ul className="grid grid-cols-1 gap-y-3 !p-0">
                  {footerData.products.map((item, i) => (
                    <li key={i}>
                      <Link to={item.link} className="text-[13px] md:text-[14px] text-[#01386A] hover:text-[#01386A] transition-all block">
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

          </div>

          <div className="hidden md:block absolute right-[-20px] lg:right-0 top-1/2 -translate-y-1/2 z-0 pointer-events-none drop-shadow-[0_0_25px_rgba(0,123,255,0.4)]">
            <img
              src="/assets/footer/wrap1.png"
              alt=""
              className="w-[280px] lg:w-[380px] object-contain mix-blend-screen opacity-90"
            />
          </div>

        </div>

        <div className="flex flex-col md:flex-row justify-between items-center py-6 font-graphik text-[13px] md:text-[14px] text-[#01386A]">
          <p className="order-2 md:order-1 mt-4 md:mt-0">© Mobikode 2026.</p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8 order-1 md:order-2">
            <Link to="/faq" className="hover:text-[#01386A] transition-colors">FAQ</Link>
            <Link to="/terms-condition" className="hover:text-[#01386A] transition-colors">Terms & Conditions</Link>
            <Link to="/privacy-policy" className="hover:text-[#01386A] transition-colors">Privacy Policy</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

const SocialIcon2 = ({ icon, link = "#" }) => (
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className="w-[36px] h-[36px] flex items-center justify-center border border-[#01386A] hover:bg-white hover:text-[#0E2A62] transition-all duration-300"
  >
    {icon}
  </a>
);

export default DemoFooter;